/* eslint-disable react-hooks/exhaustive-deps */
import Link from 'next/link'
import { Divider } from 'antd'
import { Project } from 'src/core/models'
import { CustomCard } from 'src/components'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import React, { useEffect, useState } from 'react'
import { getProjectsFiltered } from 'src/core/helpers'
import { ProjectCard } from '@climatetrade/components'
import EmptyProjectCard from './EmptyProjectCard/EmptyProjectCard'
import MyProjectListHeader from './MyProjectListHeader/MyProjectListHeader'
import {
  userProjectListFilterSelector,
  userProjectListSelector,
  currencyListSelector,
  selectCurrencyToken
} from 'src/features'

const MyProjectsPageContent: React.FC = () => {
  const { loading: isLoading, data: oldProjectList } = useAppSelector(userProjectListSelector)
  const [filteredProjects, setFilteredProjects] = useState<Project[]>(oldProjectList)
  const currencyList = useAppSelector(currencyListSelector)
  const selectedCurrency = useAppSelector(selectCurrencyToken)
  const filters = useAppSelector(userProjectListFilterSelector)
  const { isMobile } = useWindowSize()

  useEffect(() => { // Manage Project Filtering
    const newList = getProjectsFiltered(filters, oldProjectList)
    setFilteredProjects(newList)
  }, [filters])

  return <>
    <CustomCard loading={isLoading}>
      <MyProjectListHeader projectsLength={filteredProjects.length} />
      <Divider />
      {/* Project Cards */}
      <div className='columns is-multiline'>
        {filteredProjects.map((project: Project) => (
          <div key={project.id} className='column is-4'>
            <Link href={`/my-projects/details?id=${project.id}`} passHref legacyBehavior>
              <a>
                <ProjectCard
                  project={project}
                  currencyList={currencyList}
                  userCurrencyCode={selectedCurrency}
                  dimensionsHeight={isMobile ? 224 : 322}
                  dimensionsWidth={isMobile ? 328 : 310}
                />
              </a>
            </Link>
          </div>
        ))}
        <div className='column is-4'>
          <EmptyProjectCard />
        </div>
      </div>
    </CustomCard>
  </>
}

export default MyProjectsPageContent
